import { ModuleWithProviders, NgModule } from '@angular/core';
import { FacebookPixelConfig, FACEBOOK_PIXEL_CONFIG } from '@shared/services/facebook-pixel.config';
import { FacebookPixelService } from '@shared/services/facebook-pixel.service';

@NgModule({})
export class FacebookPixelModule {
  constructor(private pixelService: FacebookPixelService) {
    // Injecting the service here ensures it is instantiated when the module loads.
  }

  static forRoot(config: FacebookPixelConfig): ModuleWithProviders<FacebookPixelModule> {
    return {
      ngModule: FacebookPixelModule,
      providers: [
        FacebookPixelService,
        { provide: FACEBOOK_PIXEL_CONFIG, useValue: config }
      ]
    };
  }
}
